import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

// 根据商品ID获取商品详情
export const getProductDetail = (params: object = {}) => $http.get('/ptapi/products/products_one', params)

/**
 * 根据品牌ID获取商品列表
 * @param   brand_id：品牌ID
 *          title：商品名称
 *          product_id：商品ID
 * @returns object
 */
export const getProductListApi = (params) => $http.get('/cake/product_list', params)

// 获取自动下架商品列表
export const getAutoOffProductListApi = (params) => $http.get('/cake_api/goods_list', params)

// 自动下架商品列表上架
export const updateProductStatusApi = (data) => $http.get('/cake_api/goods_status', data)

// 根据商品ID获取规格信息
export const getSpecsApi = (product_id:any) => $http.get('/distribution/get_specs_info', {product_id})

// 判断是否有因延迟发货导致下架的商品
export const existDelayProductApi = () => $http.get('/cake_api/goods_msg')
// 更新商品状态
export const updateProductStatus = (data) => $http.get('/cake_api/goods_status', data)
// 商户已收到通知后台
export const updateProductNoticeStatusApi = (id) => $http.get('/cake_api/goods_hide', {id})

// 商品审核撤销
export const checkRollback = (params) => $http.get('/cake_api/product_rollback', params)

// 商品规格上下架
export const updateSpecStatusAPi = (specs_id:number,is_admin?:number) => $http.get('/cake_api/specs_status', { specs_id,is_admin })

/**
 * 全平台总商品列表（包括实物、电子券，上架下架等等）商品
 * @param   brand_id：品牌ID
 *          status 状态（1是上架，2是下架，0或者不传是全部）
 *          cat_id 代表分类id
 * @returns object
 */
export const getProductListAllApi = (params) => $http.get('/cake_api/get_brand_products', params)

/**
 * 根据品牌或二级品牌列表商品列表，不分页
 * brand_id：品牌ID
 * second_brand_ids：二级品牌ID
 */
export const getProductListByParamsAPi = (params = {}) => $http.get('/cake/product_list', params)

/**
 * 校验商品配料表图是否合规：必须有可识别文字才行
 * url_img：图片地址
 */
export const checkIngredientsImage = (url_img:string) => $http.get('/cake_api/imgcheck', { url_img })

/**
 * 根据商品ID获取商品列表
 * @param product_ids  必填    商品ID
 * */ 
export const getProductListByIdsApi = (product_ids: string) => $http.get('/sys/admin/getProductList', { product_ids })

/**
 * 根据规格ID获取规格列表
 * @param spec_ids  必填    规格ID
 * */ 
export const getSpecListByIdsApi = (spec_ids: string) => $http.get('/sys/admin/getSpecList', { spec_ids })
